/**
 * calculates days between start and end. will always return positive numbers even if start is after end
 * @param start
 * @param end
 */
export function calcDays(start: Date, end: Date): number {
  return Math.round((end.getTime() - start.getTime()) / (1000 * 3600 * 24));
}

/**
 * calculates hours from start until end. will return negative time if start is after end
 * @param start date from
 * @param end date until
 */
export function calcHours(start: Date, end: Date): number {
  return Math.round((end.getTime() - start.getTime()) / (1000 * 3600));
}

/**
 * Returns true, if the min-delay is succeed with the given start-date,
 * false if not.
 *
 * @param start
 * @param min_delay
 */
export function violatesMinDelay(start: Date, min_delay: number): boolean {
  const now = new Date();
  return calcHours(now, start) < min_delay;
}

/**
 * Returns true, if the min-duration is succeed with the given start-and end-date,
 * false if not.
 *
 * @param start
 * @param end
 * @param minDuration
 */
export function violatesMinDuration(start: Date, end: Date, minDuration: number): boolean {
  start.setHours(0, 0, 0, 0); // set start and
  end.setHours(23, 59, 59, 999); // end to reflect a "day";
  return calcDays(start, end) < minDuration;
}

/**
 * Returns true, if the max-duration is succeed with the given start-and end-date,
 * false if not.
 *
 * @param start
 * @param end
 * @param maxDuration
 */
export function violatesMaxDuration(start: Date, end: Date, maxDuration: number): boolean {
  start.setHours(0, 0, 0, 0); // set start and
  end.setHours(23, 59, 59, 999); // end to reflect a "day";
  return calcDays(start, end) > maxDuration;
}
